<template>
  <div class="memberContainer">
    <nav-bar style="width: 100%" :type="type" />

    <div id="external-toolbar"></div>

    <div class="mainInnerContainer">
      <div class="editContain">
        <div class="box">
          <div class="draftContain" v-if="draftLatest.nd_id">
            <div class="draftLabel">草稿</div>
            <div class="draftTitle">
              {{ draftLatest.nd_title || "【无标题】" }}
            </div>
            <div class="draftEdit" @click="editDraft()">继续编辑</div>
            <div class="moreDraftContain" @click="toDraft()">
              <div class="moreDraftContainTitle">更多</div>
              <img src="../../assets/new/gengduo 10@2x.png" class="moreDraftContainIcon" />
            </div>
            <img src="../../assets/new/x@2x.png" class="closeDraft" @click="addIgnoreDraft()" />
          </div>

          <!-- 富文本部分 -->
          <div class="script">
            <!-- 标题输入框 -->
            <div class="titleContain">
              <el-input class="title" v-model="title" placeholder="请输入标题文字(2-35字)" placeholder-class="input-placeholder"
                autosize resize="none" @keydown.enter.native="handleTextareaKeydown" />
              <p class="titleLength">
                <span :class="{ toLong: title.length > 35 && !$route.query.uid }">{{ title.length }}</span><span
                  v-if="!$route.query.uid">/35</span>
              </p>
            </div>
            <p class="titleTooLongAlert" v-if="titleTooLongShow && title.length > 35 && !$route.query.uid">
              标题长度应在 2-35 个字之间
            </p>
            <!-- 富文本编译器 -->
            <vue-tinymce v-model="content" :setup="setup" :setting="setting$" @change="changeClick($event)" />
          </div>
          <!-- {{charTotal$}} {{imgNum$}} -->
        </div>

        <div class="right">
          <info-set ref="infoSet" :text_number="charTotal$" :img_number="imgNum$" :title="title" :content="content"
            :resource_url="resource_url" :material_ids="ids$" :topicIds="[]" :abstractAi="abstractAi" type="1"
            @preview="preview" @titleTooLong="titleTooLong" />
        </div>
      </div>

      <div class="aiContain" v-show="aiContainShow" :class="{ scrollHeigth: aiScroll }">
        <div class="aiNavContain">
          <div class="aiNavs">
            <div class="aiNav" :class="{ aiActive: aiIndex == 0 }" @click="aiTabShow(0)">
              <p class="aiNavText">AI 创作</p>
              <div class="aiNavLine"></div>
            </div>
            <div class="aiNav" :class="{ aiActive: aiIndex == 1 }" @click="showSuggest()">
              <p class="aiNavText">智能纠错</p>
              <div class="aiNavLine"></div>
            </div>
            <!-- <div
              class="aiNav"
              :class="{ aiActive: aiIndex == 2 }"
              @click="aiTabShow(2)"
            >
              <p class="aiNavText">图像生成</p>
              <div class="aiNavLine"></div>
            </div> -->
            <div class="aiNav" :class="{ aiActive: aiIndex == 3 }" @click="aiTabShow(3)">
              <p class="aiNavText">DeepSeek</p>
              <div class="aiNavLine"></div>
            </div>
          </div>
          <img src="../../assets/script/aiClose.png" class="aiCloseIcon" @click="tooltBraHide()" />
        </div>
        <div class="aiContactContain" v-if="aiIndex == 0">
          <div class="aiScrollContain">
            <div class="stableContain">
              <p class="stableText">Hi，我是顶端发文助手，我可以帮你进行：</p>
              <div class="aiFunContain">
                <div v-for="(item, index) in aiFuns" :key="index" class="aiFunItem" @click="aiFunSelect(index)">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="chatContain">
              <div class="chatList" v-for="(item, index) in chatList" :key="index">
                <img :src="item.isUser
                  ? u_avatar
                  : 'https://img.dingxinwen.cn/image/20241029/9e6fc8219579bad5dfcf99c31222712e.png'
                  " class="chatHead" />
                <p class="chatName">
                  {{ item.isUser ? "我" : "创作助手" }}
                </p>
                <el-image class="chatImg" :src="item.img" :preview-src-list="[item.img]"
                  v-if="item.img && !item.binaryData" @load="aiScrollBottom()" />
                <div class="chatContent" v-if="!item.titles || item.content == '抱歉，未找到相关结果，建议调整输入内容'"
                  v-html="item.content"></div>
                <div class="chatTitle" v-if="item.titles && item.content != '抱歉，未找到相关结果，建议调整输入内容'">
                  <p class="chatTitleText" :class="{ chatTitleActive: chatTitleIndex == index }"
                    v-for="(item, index) in item.titles" :key="index" @click="chatTitleIndex = index">
                    {{ item }}
                  </p>
                </div>
                <div v-if="!item.isUser && item.isFinish">
                  <p class="aiAlert">
                    内容由AI生成，请仔细甄别
                  </p>
                  <div class="btnContain" v-if="item.content != '抱歉，未找到相关结果，建议调整输入内容'">
                    <div class="addToContent" @click="aiInsertContent(item)">
                      添加到{{
                        item.question.indexOf("请根据内容进行摘要推荐") > -1
                          ? "摘要"
                          : item.titles
                            ? "标题"
                            : "正文"
                      }}
                    </div>
                    <div class="copyBtn" v-if="!item.titles" @click="aiCopy(index)">
                      复制
                    </div>
                    <div class="reTryBtn" @click="aiReTry(item)">重试</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chatInputContain">
            <input v-model="chatInput" placeholder="输入创作主题、观点或大纲，AI帮你写" maxlength="100" class="chatInput"
              @keyup.enter="aiSend()" />
            <img src="../../assets/script/aiSend.png" class="aiSendIcon" @click="aiSend()" />
          </div>
        </div>
        <div class="aiSuggestionContain myScroll" v-else-if="aiIndex == 1" v-loading="aiSuggestionLoading"
          element-loading-text="检测中...">
          <div class="checkContain">
            <p class="suggestionText" v-if="suggestionList.length == 0">
              暂无建议
            </p>
            <p class="suggestionText" v-else>
              共 <span class="suggestionNum">1</span> 条建议
            </p>
            <div class="reCheckContain" @click="reDoSuggestion()">
              <img src="../../assets/script/refresh.png" class="refreshIcon" />
              <p class="reCheckText">重新检测</p>
            </div>
          </div>
          <p class="noWrongWord" v-if="suggestionList.length == 0 && !aiSuggestionLoading">
            检测成功，无异常
          </p>
          <div class="wrongCountContain" v-if="suggestionList.length">
            <p class="suggestionLength">{{ suggestionList.length }} 处错别字</p>
            <div class="correctWordContain" @click="suggestionEditAll()">
              <img src="../../assets/script/editIcon.png" class="correctWordIcon" />
              <p class="correctWordText">一键修改</p>
            </div>
          </div>
          <div class="suggestionListContain">
            <div class="suggestionItem" v-for="(item, index) in suggestionList" :key="index">
              <div class="suggestionInner">
                <div class="dot"></div>
                <p>{{ item.old }}</p>
                <img src="../../assets/script/arrow.png" class="suggestionIcon" />
                <p>{{ item.new }}</p>
              </div>
              <p class="editBtn" @click="suggestionEdit(index)">修改</p>
            </div>
          </div>
        </div>
        <div class="aiContactContain" v-if="aiIndex == 2">
          <div class="aiScrollContain myScroll">
            <div class="stableContain">
              <p class="stableText">
                一句话即可生成图片，支持多种风格，快来试试看吧~
              </p>
            </div>
            <div class="chatContain">
              <div class="chatList" v-for="(item, index) in imgChatList" :key="index">
                <img :src="item.isUser
                  ? u_avatar
                  : 'https://img.dingxinwen.cn/image/20241029/9e6fc8219579bad5dfcf99c31222712e.png'
                  " class="chatHead" />
                <p class="chatName">
                  {{ item.isUser ? "我" : "创作助手" }}
                </p>
                <el-image class="chatImg" :src="item.img" :preview-src-list="[item.img]" v-if="item.img"
                  @load="aiImgScrollBottom()" />
                <div class="chatContent" v-if="item.text" v-html="item.text"></div>
                <div v-if="!item.isUser">
                  <p class="aiAlert">
                    内容由AI生成，请仔细甄别
                  </p>
                  <div class="btnContain">
                    <div class="addToContent" @click="aiImgInsertContent(item)" v-if="item.img">
                      添加到正文
                    </div>
                    <div class="reTryBtn" @click="aiImgReTry(item)">重试</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="chatInputContain chatAiInputContain">
            <div class="aiImgUploadedContain" v-if="aiImgUpload">
              <img :src="aiImgUpload" class="aiImgUploaded" />
              <img src="../../assets/script/delete.png" class="aiImgDeleteClose" @click="aiImgUpload = ''" />
            </div>
            <input v-model="chatImgInput" placeholder="描述你所想象的画面，角色，情绪，场景，风格..." maxlength="100" class="chatInput"
              @keyup.enter="aiImgSend()" />
            <div class="imgInfoContain">
              <div class="btnContain">
                <div class="uploadAiImg" @click="aiUploadImg()">
                  <img src="../../assets/script/aiUpload.png" class="aiUploadIcon" />
                  <p class="aiUploadText">参考图片</p>
                </div>
                <el-dropdown trigger="click" placement="top" @command="imgRadioCommand" v-if="!aiImgUpload">
                  <div class="uploadAiImg">
                    <img src="../../assets/script/aiRadio.png" class="aiUploadIcon" />
                    <p class="aiUploadText">
                      {{ imgRadio[imgRadioIndex].label }}
                    </p>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in imgRadio" :key="index" class="imgRadioContain"
                      :command="item.label">
                      <img :src="item.icon" class="aiRadioImg" />
                      <p class="aiRadioText">{{ item.label }}</p>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown trigger="click" placement="top" @command="imgStyleCommand">
                  <div class="uploadAiImg">
                    <img src="../../assets/script/aiStyle.png" class="aiUploadIcon" />
                    <p class="aiUploadText">
                      {{ imgStyle[imgStyleIndex].text }}
                    </p>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in imgStyle" :key="index" class="imgStyleContain"
                      :command="item.text">
                      <img :src="item.img" class="aiStyleImg" />
                      <p class="aiStyleText">{{ item.text }}</p>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <img src="../../assets/script/aiSend.png" class="aiSendIcon" @click="aiImgSend()" />
            </div>
          </div>
        </div>
        <div class="deepseekContain" v-if="aiIndex == 3">
          <iframe src="https://m.topnews.cn/as/pages/chat/chat"></iframe>
        </div>
      </div>
    </div>

    <el-dialog title="预览" :visible.sync="previewVisible" width="320px" top="5vh" class="previewContainer"
      @close="previewContent = ''" :class="{ blackPage: blackPage }">
      <p class="title">{{ title }}</p>
      <div class="info">
        <img :src="u_avatar" />
        <div>
          <p class="userName">{{ u_nickname }}</p>
          <p class="time">{{ getNowTime() }}</p>
        </div>
      </div>
      <div v-html="previewContent" class="content"></div>
      <img src="../../assets/script/close.png" class="closeBtn" @click="previewVisible = false" />
    </el-dialog>

    <el-dialog title="插入话题" :visible.sync="insertTopicVisible" width="600px" class="insertTopicContainer">
      <el-select v-model="topicValue" filterable remote default-first-option placeholder="请输入或者选择话题"
        :remote-method="getTopicList" @change="topicInputChange">
        <el-option v-for="item in topicOptions" :key="item.id" :label="item.title" :value="item.id" style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 550px;
          ">
          <span v-if="item.is_official == 1" style="color: #ea0e0e">(官方)</span>{{ item.title }}
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="insertTopicVisible = false">取消</div>
        <div class="submitBtn" type="primary" @click="insertTopicFn">确定</div>
      </div>
    </el-dialog>

    <div class="uploadVideoBg" v-if="videoUploading"></div>

    <div class="forPreviewContainer" v-html="forPreview" style="display: none" ref="forPreviewContainer"></div>

    <el-dialog title="" :visible.sync="insertImgVisible" width="702px" top="5vh" class="insertImgContainer">
      <el-tabs v-model="activeInsertImg" @tab-click="insertImgClick">
        <el-tab-pane label="上传图片" name="0">
          <div class="uploadImgContain localImg" :class="{ shaortUpload: uploadImgUrls.length }">
            <div class="uploadBtn" @click="toUploadImg()">
              <img src="../../assets/script/local.png" class="uploadIcon" />
              <p class="uploadText">本地上传</p>
            </div>
            <p class="uploadInfo" v-if="!uploadImgUrls.length">
              支持jpg、jpeg、png等多种格式，单张图片最大支持20MB
            </p>
          </div>
          <div class="uploadImgUrlsContain" v-if="uploadImgUrls.length">
            <div class="uploadImgUrlInner" v-for="(item, index) in uploadImgUrls" :key="index">
              <img :src="item" class="uploadedImg" />
              <img src="../../assets/script/delete.png" class="deleteImg" @click="deleteImg(index)" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="我的素材" name="1">
          <div class="uploadImgContain myMatri" v-scroll="handleScroll">
            <div class="myMatriList">
              <div class="matriListContain" v-for="(item, index) in matriList" :key="index"
                :class="{ matriActive: index == matriIndex }" @click="matriIndex = index">
                <img :src="item.cm_url" class="matriImg" />
              </div>
            </div>
            <p class="noMatri">没有更多了</p>
          </div>
        </el-tab-pane>
        <el-tab-pane label="公共素材" name="2">
          <div class="uploadImgContain allMatri" v-scroll="handleScroll">
            <div class="myMatriList">
              <div class="matriListContain" v-for="(item, index) in matriList" :key="index"
                :class="{ matriActive: index == matriIndex }" @click="matriIndex = index">
                <img :src="item.cm_url" class="matriImg" />
              </div>
            </div>
            <p class="noMatri">没有更多了</p>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="insertImgVisible = false">取消</div>
        <div class="submitBtn" type="primary" @click="insertImgFn">确定</div>
      </div>
    </el-dialog>

    <el-dialog title="插入链接" :visible.sync="insertLinkVisible" width="600px" class="insertLinkContainer">
      <div class="insertLinkContain">
        <p class="insertLinkLabel">链接地址</p>
        <el-input class="insertLink" v-model="insertLinkUrl" placeholder="请输入" placeholder-class="input-placeholder" />
      </div>
      <div class="insertLinkContain">
        <p class="insertLinkLabel">显示文字</p>
        <el-input class="insertLink" v-model="insertLinkTitle" placeholder="请输入"
          placeholder-class="input-placeholder" />
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="insertLinkVisible = false">取消</div>
        <div class="submitBtn" type="primary" @click="insertLinkFn">确定</div>
      </div>
    </el-dialog>

    <el-dialog title="插入电话" :visible.sync="insertTelVisible" width="600px" class="insertTelContainer">
      <el-input class="insertTel" v-model="insertTel" placeholder="请输入" placeholder-class="input-placeholder"
        maxlength="11" />
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="insertTelVisible = false">取消</div>
        <div class="submitBtn" type="primary" @click="insertTelFn">确定</div>
      </div>
    </el-dialog>

    <input type="file" :multiple="isUploadAi || isUploadAiText ? false : true" @change="fileChangeImg" id="uploadImg"
      style="display: none" />
  </div>
</template>

<script>
import { of, merge, combineLatest, from, BehaviorSubject, Subject } from "rxjs";
import {
  pipe,
  filter,
  pluck,
  switchMap,
  catchError,
  map,
} from "rxjs/operators";
import { setting$ } from "@/utils/store-rx.js";
import { dispatch } from "frer";
import Event from "qc-event-bus";
import NavBar from "../../components/NavBarForEdit";
import InfoSet from "./components/InfoSet";
import {
  RESOURCE_HOST,
  SWNEWS_HOST,
  NEWS_HOST,
  MEDIA_HOST,
  ROBOT_HOST,
} from "../../constants/apiHosts";
import editorObj from "../../utils/tiny-setting";
import map_callback from "../../utils/uploadVideo";
import map_callback_audio from "../../utils/uploadAudio";
import { HS_upload } from "./../../utils/huoshanUpload";
import qs from "qs";
import config from "@/config/index.js";
import md5 from "../../utils/md5";

export default {
  data() {
    return {
      progressPercentArray: {},
      content: "",
      title: "",
      event: new Event(),
      resource_url: [],
      belong_id: "",
      previewVisible: false,
      materialMap: {},
      u_avatar: "",
      u_nickname: "",
      type: 1,
      defaultO: ["1"],
      defaultActive: "0-1",
      open: false,
      cm_type: 2,
      previewContent: "",
      videoUploading: false,
      forPreview: "",
      list$: [],
      total$: 0,
      insertTopicVisible: false,
      topicOptions: [],
      topicValue: "",
      editorMain: {},
      blackPage: false,
      insertImgVisible: false,
      activeInsertImg: "0",
      uploadImgUrls: [],
      matriList: [],
      matriListPage: 1,
      matriListAll: false,
      matriIndex: -1,
      aiContainShow: true,
      aiIndex: 0,
      aiFuns: [
        {
          name: "标题推荐",
          code: 0,
        },
        {
          name: "扩写",
          code: 1,
        },
        {
          name: "润色",
          code: 2,
        },
        {
          name: "修改语气",
          code: 3,
        },
        {
          name: "摘要推荐",
          code: 4,
        },
        // {
        //   name: "图像配文",
        //   code: 5,
        // },
      ],
      chatInput: "",
      aiScroll: false,
      suggestionList: [],
      chatList: [],
      lastSelection: "",
      chatTitleIndex: -1,
      aiSuggestionLoading: false,
      aiImgUpload: "",
      aiImgUploadFile: "",
      isUploadAi: false,
      imgRadio: [
        {
          icon: "https://img.dingxinwen.cn/image/20241102/745328780136091bfbc0683a37fd9ab2.jpg",
          label: "1:1",
          value: "768*768",
        },
        {
          icon: "https://img.dingxinwen.cn/image/20241102/7090df52527641f9e2501e1a16a2b61f.jpg",
          label: "4:3",
          value: "768*576",
        },
        {
          icon: "https://img.dingxinwen.cn/image/20241102/a8975345994e8e75f6f877769b1e11ab.jpg",
          label: "16:9",
          value: "768*432",
        },
        {
          icon: "https://img.dingxinwen.cn/image/20241102/0c1bfc820dcef3ba94cdc24c508f5b25.jpg",
          label: "9:16",
          value: "432*768",
        },
      ],
      imgStyle: [
        {
          img: "https://img.dingxinwen.cn/image/20241102/5e0df0a369d6e50be1950f87cfbea1b1.jpg",
          text: "人像摄影",
        },
        {
          img: "https://img.dingxinwen.cn/image/20241102/6a0fe7c74da8a68439391d3a44b70980.jpg",
          text: "风景",
        },
        {
          img: "https://img.dingxinwen.cn/image/20241102/7fb325e66fb310f0e4ef5593b015a562.jpg",
          text: "国风插画",
        },
        {
          img: "https://img.dingxinwen.cn/image/20241102/95afc1dd8dc96840b562bb8b2b971905.jpg",
          text: "动漫",
        },
        {
          img: "https://img.dingxinwen.cn/image/20241102/144c5e78e3dfddae09c4403027425955.jpg",
          text: "3D",
        },
        {
          img: "https://img.dingxinwen.cn/image/20241102/49ba3eb112f67e01c0c7d4ac793f2ca7.jpg",
          text: "艺术",
        },
      ],
      imgRadioIndex: 0,
      imgStyleIndex: 0,
      chatImgInput: "",
      imgChatList: [],
      imgCreating: false,
      chatSending: false,
      insertTelVisible: false,
      insertTel: "",
      insertLinkVisible: false,
      insertLinkUrl: "",
      insertLinkTitle: "",
      abstractAi: "",
      isUploadAiText: false,
      aiImgTextFile: {},
      titleTooLongShow: false,
      draftLatest: {},
    };
  },
  subscriptions() {
    return {
      setting$,
      imgNum$: new BehaviorSubject(0),
      type$: new BehaviorSubject(0), //0是img ，1是video
      charTotal$: new BehaviorSubject(0),
      ids$: new BehaviorSubject(""),
      /* open$:new BehaviorSubject(false) */
      tabs$: new BehaviorSubject(["我的素材", "公共素材"]),
      tabIndex$: new BehaviorSubject(0), //我的素材还是公共素材
    };
  },
  components: {
    NavBar,
    InfoSet,
  },
  watch: {
    progressPercentArray: {
      handler: function (newValue, oldValue) {
        for (let item in newValue) {
          if (newValue[item] <= 100) {
            let videoItems = document.getElementsByClassName("get-cover");
            videoItems = Array.from(videoItems);
            videoItems.forEach((item1) => {
              if (item1.getAttribute("data-nanoid") == item) {
                let processItem =
                  item1.getElementsByClassName("videoProcess")[0];
                if (processItem) {
                  processItem.style.width = newValue[item] + "%";
                }
              }
            });
          }
        }
      },
      deep: true,
    },
  },
  directives: {
    // 定义scroll指令
    scroll: {
      inserted(el, binding) {
        // 为元素添加滚动事件监听器
        el.addEventListener("scroll", () => {
          // 获取滚动位置
          const scrollTop = el;
          // 执行绑定的函数，并传递滚动位置作为参数
          binding.value(scrollTop);
        });
      },
    },
  },
  created() {
    let oMeta = document.createElement("meta");
    oMeta.name = "referrer";
    oMeta.content = "no-referrer";
    document.getElementsByTagName("head")[0].appendChild(oMeta);

    this.u_avatar = localStorage.getItem("u_avatar")
      ? localStorage.getItem("u_avatar")
      : require("../../assets/moren.png");
    this.u_nickname = localStorage.getItem("u_nickname");

    //tinymce配置信息获取
    dispatch("setting");
  },
  mounted() {
    // 只有系统弹出框才会阻止
    window.addEventListener("beforeunload", this.closeAlert, false);

    //这里进行使用资源统计
    let that = this;

    /*-------------------------------
     *外部素材的添加监听
     *-------------------------------*/
    this.event.on("video", (val) => {
      that.content = that.content.replace("</body>", val);
    });
    this.event.on("img", (val) => {
      that.content = that.content.replace("</body>", val);
    });

    let update$ = this.$watchAsObservable("content").pipe(pluck("newValue"));

    /*-------------------------------
     *字数和图片数量的统计
     *-------------------------------*/
    this.$subscribeTo(update$, (val) => {
      let arr = val.split(`alt=""`);
      if (arr.length > 1) {
        this.$observables.imgNum$.next(arr.length - 1);
      } else {
        this.$observables.imgNum$.next(0);
      }
      val = val.replace(/<\/?[^>]+(>|$)/g, ""); //惰性量词查找并且非捕获
      val = val.replace(
        /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
        ""
      );
      val = val.replace(/style\s*?=\s*?(['"])[\s\S]*?\1/g, "");
      val = val.replace(/\s*/g, "");
      val = val.replace(/&nbsp;/gi, "");
      val = val.replace(/&ensp;/gi, "");
      val = val.replace(/&emsp;/gi, "");
      val = val.replace(/&thinsp;/gi, "");
      val = val.replace(/&zwnj;/gi, "");
      val = val.replace(/&zwj;/gi, "");
      //val = val.replace(/&middot;/gi, "");
      val = val.replace(/&ldquo;/gi, "");
      val = val.replace(/&rdquo;/gi, "");
      val = val.replace(/&hellip;/gi, "");
      //val = val.replace(/&lsquo;/gi, "");
      //val = val.replace(/&rsquo;/gi, "");
      this.$observables.charTotal$.next(val.length);
    });

    /*-------------------------------
     *material_ids的动态统计
     *-------------------------------*/
    this.$subscribeTo(update$, (val) => {
      var ids = [];
      Object.keys(that.materialMap).forEach((item, index) => {
        //便利keys，从整体中找包含关系
        if (val.indexOf(item) != -1) {
          ids.push(that.materialMap[item]);
        }
      });
      let set = new Set(ids);
      ids = Array.from(set);
      let ids_str = ids.join(",");
      this.$observables.ids$.next(ids_str);
    });

    this.tabClick(0);

    // this传给编辑器js，接受上传百分比
    editorObj.map_callback(this);
    map_callback(this);
    map_callback_audio(this);

    window.addEventListener("message", (event) => {
      if (event.data == "openInsertImg") {
        this.uploadImgUrls = [];
        this.insertImgVisible = true;
      } else if (event.data == "openInsertTel") {
        this.insertTel = "";
        this.insertTelVisible = true;
      } else if (event.data == "openInsertLink") {
        this.insertLinkUrl = "";
        this.insertLinkTitle = "";
        if (
          this.editorMain.selection.getContent() &&
          this.editorMain.selection.getContent().indexOf("<img") < 0
        ) {
          this.insertLinkTitle = this.editorMain.selection.getContent();
        }
        this.insertLinkVisible = true;
      } else if (event.data == "openExpansion") {
        this.aiTabShow(0);
        this.$nextTick(() => {
          this.aiCreateText(
            "请对以下内容进行扩写：" + this.editorMain.selection.getContent()
          );
        });
        let chatInput = document.getElementsByClassName("chatInput")[0];
        chatInput.focus();
      } else if (event.data == "openPolish") {
        this.aiTabShow(0);
        this.$nextTick(() => {
          this.aiCreateText(
            "请对以下内容进行润色：" + this.editorMain.selection.getContent()
          );
        });
        let chatInput = document.getElementsByClassName("chatInput")[0];
        chatInput.focus();
      } else if (event.data == "openTone") {
        this.aiTabShow(0);
        this.$nextTick(() => {
          this.aiCreateText(
            "请修改以下内容的语气：" + this.editorMain.selection.getContent()
          );
        });
        let chatInput = document.getElementsByClassName("chatInput")[0];
        chatInput.focus();
      } else if (event.data == "openAi") {
        if (!this.aiContainShow) {
          this.aiIndex = 0;
          this.aiContainShow = true;

          let tooleBarPosition = document.getElementsByClassName(
            "tox-toolbar-overlord"
          )[0];
          tooleBarPosition.style.marginLeft = "0";
          let innerContainer =
            document.getElementsByClassName("innerContainer")[0];
          innerContainer.style.marginLeft = "-395px";
        } else {
          this.tooltBraHide();
        }
      } else if (event.data == "pasteImgDone") {
        setTimeout(() => {
          this.$refs.infoSet.getThumbAuto(1);
        }, 1000);
      }
    });

    window.addEventListener("scroll", (e) => {
      if (window.scrollY >= 72) {
        this.aiScroll = true;
      } else {
        this.aiScroll = false;
      }
    });

    if (!this.$route.query.draftId) {
      this.getLastDraft();
    }
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.closeAlert, {
      passive: false,
    });
  },
  methods: {
    getAllDetail() {
      if (this.$route.query.draftId) {
        this.belong_id = this.$route.query.draftId;
        this.$subscribeTo(
          from(
            this.$axios.get(
              `${RESOURCE_HOST}/api/draft/show?id=${this.belong_id}`
            )
          ).pipe(catchError((val) => of(val))),
          (res) => {
            if (res.data.code == 0) {
              let detail = res.data.data;
              this.title = detail.nd_title;
              detail.nd_content = detail.nd_content.replace(
                /class="topicid/gi,
                'class="topicid" contenteditable="false'
              );
              this.content = detail.nd_content;
              // this.resource_url = detail.nd_resource_url;

              this.$nextTick(() => {
                if (
                  document.getElementsByClassName("mce-content-body").length
                ) {
                  let editorElem =
                    document.getElementsByClassName("mce-content-body")[0];
                  let figcaption =
                    editorElem.getElementsByTagName("figcaption");
                  if (figcaption.length > 0) {
                    figcaption = Array.from(figcaption);
                    figcaption.forEach((elem, index) => {
                      elem.setAttribute("contenteditable", true);
                    });
                  }
                }
              });
            } else {
              this.$message.error(res.data.msg);
            }
          }
        );
        // 稿件跳转
      } else if (this.$route.query.scriptId) {
        this.belong_id = this.$route.query.scriptId;
        this.$subscribeTo(
          from(
            this.$axios.get(
              this.$route.query.isPub == 1
                ? `${SWNEWS_HOST}/api/news/getNewsInfo?id=${this.$route.query.nid}`
                : `${RESOURCE_HOST}/api/manuscript/show?id=${this.belong_id}`
            )
          ).pipe(catchError((val) => of(val))),
          (res) => {
            if (res.data.code == 0) {
              if (this.$route.query.isPub == 1) {
                for (let key in res.data.data) {
                  if (key.indexOf("n_") >= 0 && key != "n_id") {
                    res.data.data[key.replace("n_", "nm_")] =
                      res.data.data[key];
                  }
                }
              }

              let detail = res.data.data;
              this.title = detail.nm_title;
              detail.nm_content = detail.nm_content.replace(
                /class="topicid/gi,
                'class="topicid" contenteditable="false'
              ).replace(/<IMAGE/gi, '<img');
              this.content = detail.nm_content;
              // this.resource_url = detail.nm_resource_url;

              this.$nextTick(() => {
                if (
                  document.getElementsByClassName("mce-content-body").length
                ) {
                  let editorElem =
                    document.getElementsByClassName("mce-content-body")[0];
                  let figcaption =
                    editorElem.getElementsByTagName("figcaption");
                  if (figcaption.length > 0) {
                    figcaption = Array.from(figcaption);
                    figcaption.forEach((elem, index) => {
                      elem.setAttribute("contenteditable", true);
                    });
                  }
                }
              });
            } else {
              this.$message.error(res.data.msg);
            }
          }
        );
        // 发稿库跳转
      } else if (this.$route.query.materialId) {
        this.belong_id = this.$route.query.materialId;
        this.$axios
          .post(`${RESOURCE_HOST}/api/material/showChild`, {
            id: this.belong_id,
          })
          .then((res) => {
            if (res.data.code == 0) {
              let detail = res.data.data;
              let t;
              if (detail.cm_type == 2) {
                t = setInterval(() => {
                  if (this.content.indexOf("</body>") >= 0) {
                    this.content = this.content.replace(
                      "</body>",
                      `<p><img src="${detail.cm_url}" alt="" width="100%" height="auto" data-mce-src="${detail.cm_url}"></p></body>`
                    );
                    clearInterval(t);
                  }
                }, 500);

                if (!this.materialMap[detail.cm_url]) {
                  this.materialMap[detail.cm_url] = this.belong_id;
                }
              } else if (detail.cm_type == 3) {
                t = setInterval(() => {
                  if (this.content.indexOf("</body>") >= 0) {
                    this.content = this.content.replace(
                      "</body>",
                      `<p><span contenteditable="false" data-mce-object="video" class="mce-preview-object mce-object-video" data-mce-p-controls="controls" data-mce-p-src="${detail.cm_url}" data-mce-p-poster="${detail.cm_icon_url}" data-mce-html="%20" data-mce-selected="1"><video src="${detail.cm_url}" controls="controls" width="100%" height="auto" frameborder="0"></video></span></p></body>`
                    );
                    clearInterval(t);
                  }
                }, 500);

                if (!this.materialMap[detail.cm_url]) {
                  this.materialMap[detail.cm_url] = this.belong_id;
                }
              }
              console.log(this.content);
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else if (this.$route.query.dhyId) {
        // 大河云
        this.belong_id = this.$route.query.dhyId;
        this.$axios
          .get(
            `${RESOURCE_HOST}/common/cloudnews/getTmpInfo?big_cloud_id=${this.belong_id}`
          )
          .then((res) => {
            if (res.data.code == 0) {
              let detail = res.data.data;
              this.title = detail.n_title;
              detail.n_content = detail.n_content.replace(
                /class="topicid/gi,
                'class="topicid" contenteditable="false'
              );

              let reg =
                /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
              let clearArray = detail.n_content.match(reg);
              if (clearArray) {
                let imgs = [];

                if (clearArray.length > 0) {
                  let uploadImg =
                    "https://obs.dingxinwen.cn/video/20220626/f514bcbbc794acb60c862cb58d67c568.gif";
                  clearArray.forEach((item1, index1) => {
                    if (
                      [
                        "gif",
                        "jpg",
                        "jpeg",
                        "png",
                        "GIF",
                        "JPG",
                        "JPEG",
                        "PNG",
                        "img",
                        "image",
                      ].some((item) => {
                        return item1.indexOf(item) >= 0;
                      })
                    ) {
                      let htmlArray = detail.n_content.split(item1);
                      detail.n_content = htmlArray.join(uploadImg);
                      imgs.push(item1);
                    }
                  });
                }

                let promiseArr = [];
                let uploadImg =
                  "https://obs.dingxinwen.cn/video/20220626/f514bcbbc794acb60c862cb58d67c568.gif";
                let htmlSlices = detail.n_content.split(uploadImg);
                let uploaded = [];
                let uploadedImgs = [];
                let newHtml = "";

                clearArray.forEach((item, index) => {
                  promiseArr.push(
                    new Promise((resolve) => {
                      this.$axios
                        .post(`${SWNEWS_HOST}/api/aliyun/exchangePicture`, {
                          url: item
                            .replace(/\"/gi, "")
                            .replace(/&quot;/gi, "")
                            .replace(/&gt;/gi, ">"),
                        })
                        .then((res) => {
                          if (res.data.code == 0) {
                            uploaded.push(index);
                            uploadedImgs[index] = res.data.data.url;

                            newHtml = "";

                            htmlSlices.forEach((htmlItem, htmlIndex) => {
                              if (htmlIndex == htmlSlices.length - 1) {
                                newHtml += htmlItem;
                              } else if (uploaded.includes(htmlIndex)) {
                                newHtml += htmlItem + uploadedImgs[htmlIndex];
                              } else {
                                newHtml += htmlItem + uploadImg;
                              }
                            });

                            this.content = newHtml.replace(
                              />\/format\/jpg/g,
                              ""
                            );

                            resolve();
                          } else {
                            //this.$message.error(res.data.msg);

                            uploaded.push(index);
                            uploadedImgs[index] = item
                              .replace(/\"/gi, "")
                              .replace(/&quot;/gi, "")
                              .replace(/&gt;/gi, ">");

                            newHtml = "";

                            htmlSlices.forEach((htmlItem, htmlIndex) => {
                              if (htmlIndex == htmlSlices.length - 1) {
                                newHtml += htmlItem;
                              } else if (uploaded.includes(htmlIndex)) {
                                newHtml += htmlItem + uploadedImgs[htmlIndex];
                              } else {
                                newHtml += htmlItem + uploadImg;
                              }
                            });

                            this.content = newHtml.replace(
                              />\/format\/jpg/g,
                              ""
                            );

                            resolve();
                          }
                        });
                    })
                  );
                });
              } else {
                this.content = detail.n_content;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else if (this.$route.query.mediaId) {
        // 一端百面
        this.belong_id = this.$route.query.mediaId;
        this.$axios
          .get(
            `${MEDIA_HOST}/biz/outer/news/queryBy?id=${this.belong_id}&&appId=${this.$route.query.appId}&&orgId=${this.$route.query.orgId}`
          )
          .then((res) => {
            if (res.data.code == 0) {
              let detail = res.data.data;
              this.title = detail.nmTitle;
              this.content = detail.newsContent;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }

      this.getEditorContent();
    },
    getEditorContent() {
      if (!this.editorMain || !this.editorMain.getContent()) {
        setTimeout(() => {
          this.getEditorContent();
        }, 300);
      } else {
        if (this.editorMain.getContent().indexOf("wrongWord") < 0) {
          for (let i = 0; i < 3; i++) {
            // window.clearHtml(this.editorMain);
          }
        }
      }
    },
    handleScroll(element) {
      if (
        element.scrollTop + element.clientHeight + 5 >= element.scrollHeight &&
        !this.matriListAll
      ) {
        this.matriListAll = true;
        this.matriListPage += 1;
        this.getMaterialList();
      }
    },
    closeAlert(e) {
      // ios 不支持 window.onbeforeunload()
      // 将退出时间存于localstorage中
      // return "稿件尚未保存，现在离开，将导致稿件丢失！"
      e = e || window.event;

      // 兼容IE8和Firefox 4之前的版本
      if (
        (e &&
          this.content != "" &&
          this.content != '<p><br data-mce-bogus="1"></p>' &&
          this.content.replace(/\s+/g, "") !=
          "<!DOCTYPEhtml><html><head></head><body></body></html>") ||
        this.title != ""
      ) {
        e.returnValue = "稿件尚未保存，现在离开，将导致稿件丢失！";
      }

      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      if (
        (this.content != "" &&
          this.content != '<p><br data-mce-bogus="1"></p>') ||
        this.title != ""
      ) {
        return "稿件尚未保存，现在离开，将导致稿件丢失！";
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    openAndClose() {
      this.open = !this.open;
      if (this.open && this.defaultActive == "0-1") {
        this.defaultActive = "1-1";
      }
    },
    preview(setTheme) {
      if (setTheme == 0) {
        this.blackPage = true;
      } else {
        this.blackPage = false;
      }
      this.previewContent = this.content;
      let editorElem = document.getElementsByClassName("mce-content-body")[0];
      let topics = editorElem.getElementsByClassName("topicid");
      if (topics.length > 0) {
        topics = Array.from(topics);
        let contentSlice = this.previewContent.split(' class="topicid"');
        let html = contentSlice[0];
        topics.forEach((elem, index) => {
          html +=
            ' class="topicid" onclick="clickTopic(' +
            elem.id +
            ')"' +
            contentSlice[index + 1];
        });
        this.previewContent = html;
      }

      let previewContainer = document.getElementsByClassName(
        "forPreviewContainer"
      )[0];
      $(previewContainer).ready(() => {
        let videoCover = previewContainer.getElementsByClassName("get-cover");
        if (videoCover.length > 0) {
          videoCover = Array.from(videoCover);
          videoCover.forEach((elem, index) => {
            let poster = elem.getElementsByClassName("videoCover")[0].src,
              videoUrl = elem.id;
            $(
              `<p><span contenteditable="false" style="width: 100%;" data-mce-object="video" class="mce-preview-object mce-object-video" data-mce-p-controls="controls" data-mce-p-src="${videoUrl}" data-mce-p-poster="${poster}" data-mce-html="%20" data-mce-selected="1"><video src="${videoUrl}" poster="${poster}" controls="controls" style="width: 100%;" width="100%" height="auto" frameborder="0"></video></span></p>`
            ).insertAfter($(elem));
            $(elem).remove();
          });
        }

        this.previewContent = previewContainer.innerHTML;

        this.previewVisible = true;
      });

      this.forPreview = JSON.parse(
        JSON.stringify({
          content: this.previewContent,
        })
      ).content;
      this.$nextTick(() => { });
    },
    //先点击这个后点击后一个
    selectItem(item) {
      console.log("###", item);
      //跳转的时候先将原来的数据清空
      this.list$ = [];
      this.cm_type = item;
      this.tabClick(0); //只要变化就会触发
      this.open = true;
    },
    tabClick(index) {
      //tabIndex
      this.$observables.tabIndex$.next(index);
      this.$axios
        .post(`${RESOURCE_HOST}/api/material/list`, {
          all: index,
          page: 1,
          per_page: 500,
          cm_type: this.cm_type,
          cm_check: 2,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.total$ = res.data.data.total ? res.data.data.total : 0;
            this.list$ = res.data.data.data ? res.data.data.data : [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getNowTime() {
      var date = new Date();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      return (
        month +
        "月" +
        date.getDate() +
        "日 " +
        date.getHours() +
        ":" +
        date.getMinutes()
      );
    },
    backFn() {
      this.$confirm("您还未保存页面内容，确认离开吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => { });
    },
    setup(editor) {
      this.editorMain = editor;

      this.getAllDetail();

      editor.ui.registry.addIcon(
        "topic-icon",
        `<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="design-iconfont">
  <mask id="qvz3b831i__pxbfdcrhfa" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <path fill="#D9D9D9" d="M0 0H24V24H0z"/>
  </mask>
  <g mask="url(#qvz3b831i__pxbfdcrhfa)" fill="#333">
    <path d="M3.75007 8.99998C3.33585 8.99998 3.00006 8.6642 3.00006 8.24998C3.00006 7.83577 3.33585 7.49998 3.75006 7.49998L20.2501 7.49998C20.6643 7.49998 21.0001 7.83577 21.0001 8.24998C21.0001 8.6642 20.6643 8.99998 20.2501 8.99998L3.75007 8.99998Z"/>
    <path d="M3.75 15.75C3.33579 15.75 3 15.4142 3 15C3 14.5858 3.33579 14.25 3.75 14.25L20.25 14.25C20.6642 14.25 21 14.5858 21 15C21 15.4142 20.6642 15.75 20.25 15.75L3.75 15.75Z"/>
    <path d="M7.32919 20.2755C7.22198 20.6756 6.81073 20.913 6.41063 20.8058C6.01053 20.6986 5.77309 20.2874 5.8803 19.8873L10.1508 3.94948C10.258 3.54939 10.6693 3.31195 11.0694 3.41915C11.4695 3.52636 11.7069 3.93761 11.5997 4.33771L7.32919 20.2755Z"/>
    <path d="M13.8492 20.2756C13.742 20.6757 13.3307 20.9131 12.9306 20.8059C12.5305 20.6987 12.2931 20.2874 12.4003 19.8873L16.6708 3.94955C16.778 3.54945 17.1893 3.31202 17.5894 3.41922C17.9895 3.52643 18.2269 3.93768 18.1197 4.33778L13.8492 20.2756Z"/>
  </g>
</svg>`
      );

      let _this = this;
      editor.ui.registry.addButton("insertTopic", {
        icon: `topic-icon`,
        tooltip: "插入话题",
        onAction: function () {
          _this.topicValue = "";
          _this.getTopicList("");
          _this.insertTopicVisible = true;
        },
      });

      if (_this.$route.query.topicId) {
        setTimeout(() => {
          editor.insertContent(
            '<span class="topicid" contenteditable="false" style="color:#1687D9;" id="' +
            _this.$route.query.topicId +
            '" onclick="clickTopic(' +
            _this.$route.query.topicId +
            ')">#' +
            _this.$route.query.topicTitle +
            "#</span>"
          );
        }, 1000);
      }
    },
    tooltBraHide() {
      this.aiContainShow = false;

      let tooleBarPosition = document.getElementsByClassName(
        "tox-toolbar-overlord"
      )[0];
      tooleBarPosition.style.marginLeft = "388px";
      let innerContainer = document.getElementsByClassName("innerContainer")[0];
      innerContainer.style.marginLeft = "0";
    },
    changeClick($event) { },
    getTopicList(keyword) {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/hottopic/search?title=${keyword}&page=1&size=50`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.title = element.title.replace(/#/gi, "");
              if (element.id == 0) {
                element.title += "--点击添加新话题";
                element.id = element.title;
              }
            });
            this.topicOptions = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    topicInputChange(val) {
      if (typeof this.topicValue == "string") {
        this.topicValue = this.topicValue.replace(/--点击添加新话题/gi, "");
      }
    },
    insertTopicFn() {
      if (typeof this.topicValue == "string" && this.topicValue == "") {
        this.$message({
          message: "话题不能为空",
          type: "warning",
        });
      } else if (typeof this.topicValue == "string") {
        if (this.topicValue.length > 30) {
          this.$message({
            message: "话题长度不能超过30个字",
            type: "warning",
          });
          return;
        }
        this.$axios
          .post(`${NEWS_HOST}/api/hottopic/add`, {
            title: "#" + this.topicValue + "#",
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (this.checkTopic(res.data.data.id)) {
                this.$message({
                  message: "不能添加重复话题",
                  type: "warning",
                });
              } else {
                this.editorMain.insertContent(
                  '<span class="topicid" contenteditable="false" style="color:#1687D9;" id="' +
                  res.data.data.id +
                  '" onclick="clickTopic(106)">#' +
                  this.topicValue +
                  "#</span>"
                );
                this.insertTopicVisible = false;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else if (this.checkTopic(this.topicValue)) {
        this.$message({
          message: "不能添加重复话题",
          type: "warning",
        });
      } else {
        this.topicOptions.forEach((item) => {
          if (item.id == this.topicValue) {
            this.editorMain.insertContent(
              '<span class="topicid" contenteditable="false" style="color:#1687D9;" id="' +
              this.topicValue +
              '" onclick="clickTopic(106)">#' +
              item.title.replace(/#/gi, "") +
              "#</span>"
            );
            this.insertTopicVisible = false;
          }
        });
      }
    },
    checkTopic(id) {
      let editorElem = document.getElementsByClassName("mce-content-body")[0];
      let topics = editorElem.getElementsByClassName("topicid");
      let isHas = false;
      if (topics.length > 0) {
        topics = Array.from(topics);
        topics.forEach((elem, index) => {
          if (elem.id == id) {
            isHas = true;
          }
        });
      }
      return isHas;
    },
    handleTextareaKeydown() {
      let e = window.event || arguments[0];
      if (e.key === "Enter" || e.code === "Enter" || e.keyCode == 13) {
        e.returnValue = false;
        return false;
      }
    },
    getClearContent() {
      let content = this.editorMain.getContent();
      return content
        .replace(/<[^<>]+>/g, "")
        .replace(/&nbsp;/gi, "")
        .replace(/\s/g, "");
    },
    toUploadImg() {
      this.isUploadAi = false;
      this.isUploadAiText = false;
      let upload = document.getElementById("uploadImg");
      upload.value = "";
      upload.click();
    },
    deleteImg(index) {
      this.uploadImgUrls.splice(index, 1);
    },
    fileChangeImg(e) {
      let file = e.target.files;
      if (file.length) {
        let isIMAGE = true;
        for (let i = 0; i < file.length; i++) {
          if (!file[i].type.includes("image/")) {
            isIMAGE = false;
            break;
          }
        }
        if (!isIMAGE) {
          this.$message({
            message: "上传文件只能是图片格式！",
            type: "warning",
          });
        } else if (
          (this.isUploadAi || this.isUploadAiText) &&
          file[0].size > 1048576
        ) {
          this.$message({
            message: "图片大小不能超过1MB！",
            type: "warning",
          });
        } else {
          this.uploadFn(file, 0);
        }
      }
    },
    uploadFn(files, index) {
      HS_upload(
        files[index],
        (data) => {
          if (this.isUploadAi) {
            var img = new Image();
            img.onload = () => {
              var width = img.width;
              var height = img.height;
              if (width / height > 1.77 || height / width > 1.77) {
                this.$message({
                  message: "图片长边与短边比例必须小于1.77",
                  type: "warning",
                });
              } else {
                this.aiImgUpload = data.url;
                this.aiImgUploadFile = files[index];
              }
            };
            img.src = data.url;
          } else if (this.isUploadAiText) {
            this.aiImgTextFile = files[index];
            this.getImageCaption(data.url);
          } else {
            this.uploadImgUrls.push(data.url);
            if (index < files.length - 1) {
              this.uploadFn(files, index + 1);
            }
          }
        },
        (error) => {
          console.log(error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
        }
      );
    },
    insertImgClick() {
      if (this.activeInsertImg != 0) {
        this.matriList = [];
        this.matriListAll = false;
        this.matriIndex = -1;
        this.matriListPage = 1;

        this.getMaterialList();
      }
    },
    getMaterialList() {
      this.$axios
        .post(`${RESOURCE_HOST}/api/material/list`, {
          all: this.activeInsertImg == 1 ? 0 : 1,
          cm_type: 2,
          cm_check: this.activeInsertImg == 1 ? "" : 2,
          page: this.matriListPage,
          per_page: 42,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.matriList = this.matriList.concat(res.data.data.data);

            if (res.data.data.data.length >= 42) {
              this.matriListAll = false;
            } else {
              this.matriListAll = true;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    insertImgFn() {
      if (this.activeInsertImg == 0) {
        let html = "";
        this.uploadImgUrls.forEach((item) => {
          html +=
            '<p><img src="' +
            item +
            '" width="100%" height="auto" data-mce-src="' +
            item +
            '" data-mce-selected="1"></p>';
        });
        this.editorMain.insertContent(html + "<p></p>");
      } else {
        if (this.matriIndex == -1) {
          this.$message({
            message: "请选择素材",
            type: "warning",
          });
          return;
        }
        this.editorMain.insertContent(
          '<p><img src="' +
          this.matriList[this.matriIndex].cm_url +
          '" width="100%" height="auto" data-mce-src="' +
          this.matriList[this.matriIndex].cm_url +
          '" data-mce-selected="1"></p><p></p>'
        );
      }
      this.insertImgVisible = false;
    },
    aiFunSelect(index) {
      if (index == 0) {
        let content = this.getClearContent();
        if (content.length >= 50) {
          this.aiCreateText("请根据内容进行标题推荐：" + content);
        } else {
          this.chatList.push({
            isUser: 0,
            content: "正文内容必须大于等于50个字",
          });
          this.aiScrollBottom();
        }
      } else if (index == 4) {
        let content = this.getClearContent();
        if (content.length >= 50) {
          this.aiCreateText("请根据内容进行摘要推荐：" + content);
        } else {
          this.chatList.push({
            isUser: 0,
            content: "正文内容必须大于等于50个字",
          });
          this.aiScrollBottom();
        }
      } else if (index == 5) {
        this.isUploadAi = false;
        this.isUploadAiText = true;
        let upload = document.getElementById("uploadImg");
        upload.value = "";
        upload.click();
      } else {
        let content = this.editorMain.selection
          .getContent()
          .replace(/<[^>]*>/g, "");
        if (content.length) {
          this.aiCreateText(
            (index == 1
              ? "请对以下内容进行扩写："
              : index == 2
                ? "请对以下内容进行润色："
                : "请修改以下内容的语气：") + content
          );
        } else {
          this.chatList.push({
            isUser: 0,
            content: "请选择要优化的文章部分",
          });

          this.aiScrollBottom();
        }
      }
    },
    aiSend() {
      if (!this.chatInput && !this.chatSending) {
        this.$message({
          message: "请输入创作内容",
          type: "warning",
        });
      } else {
        this.aiCreateText(this.chatInput);
      }
    },
    async aiCreateText(content) {
      if (this.chatSending) {
        this.$message({
          message: "助手正在回答中，请稍后...",
          type: "warning",
        });
        return;
      } else {
        this.chatSending = true;
      }

      if (content.indexOf("请根据内容进行标题推荐") > -1) {
        this.chatList.push({
          isUser: 1,
          content: "请根据正文内容进行标题推荐",
        });
        this.chatTitleIndex = -1;
        this.chatList.push({
          isUser: 0,
          content: "",
          titles: ["生成中，请稍后..."],
          isFinish: false,
          question: "请根据内容进行标题推荐：" + content,
        });
      } else if (content.indexOf("请根据内容进行摘要推荐") > -1) {
        this.chatList.push({
          isUser: 1,
          content: "请根据正文内容进行摘要推荐",
        });
        this.chatList.push({
          isUser: 0,
          content: "",
          isFinish: false,
          question: "请根据内容进行摘要推荐：" + content,
        });
      } else {
        this.chatList.push({
          isUser: 1,
          content: content,
        });
        this.chatList.push({
          isUser: 0,
          content: "",
          isFinish: false,
          question: content,
        });
      }

      this.aiScrollBottom();

      this.chatInput = "";

      let _this = this;

      let transData = this.changeOptData({
        prompt: content,
      });
      let requestData = JSON.stringify(transData["body"]);

      fetch(`${ROBOT_HOST}/api/ai/create`, {
        method: "post",
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          authorization: transData.authorization,
          app_id: transData.app_id,
          timestamp: transData.timestamp,
          sign: transData.sign,
        },
        mode: "cors",
        credentials: "include",
        body: requestData,
      })
        .then((response) => {
          const decoder = new TextDecoder("utf-8");
          let buffer = [];
          // 获取可读流
          const reader = response.body.getReader();

          // 读取数据
          function read() {
            return reader.read().then(({ done, value }) => {
              if (done) {
                // 这里就能拿到完成的 buffer
                // 如果需要使用到完整的数据，可在这里使用，useData是你要使用数据来干嘛的函数
                return buffer;
              }
              // 读取每段流的数据块
              const chunk = decoder.decode(value, { stream: false });
              // 由于数据块中可能包含多段数据，需要额外拆分成单段数据，具体因单段数据结构而异，这里不演示
              // 例如正常是：'{a: 1}' 结构，我们使用 JSON.parse 就能转换成对象结构。
              // 结果返回了 '{a: 1}{a: 2}' 两段拼接在一起的数据，这种需要自行处理为：[{a: 1}, {a: 2}]
              let list = [];
              if (chunk.indexOf("message.completed") < 0) {
                list = _this.parseMultiJson(chunk); // 封装一个自定义函数parseMultiJson去处理.
              }
              if (chunk.indexOf("event:done") >= 0) {
                if (content.indexOf("请根据内容进行标题推荐") < 0) {
                  _this.chatList[_this.chatList.length - 1].isFinish = true;
                } else {
                  let titleArray =
                    _this.chatList[_this.chatList.length - 1].content.split(
                      "《"
                    );
                  let titles = [];
                  titleArray.forEach((item) => {
                    if (item.indexOf("》") > -1) {
                      titles.push(item.split("》")[0]);
                    }
                  });
                  if (titles.length == 1) {
                    _this.chatTitleIndex = 0;
                  } else {
                    _this.chatTitleIndex = -1;
                  }
                  _this.chatList[_this.chatList.length - 1].titles = titles;
                  _this.chatList[_this.chatList.length - 1].isFinish = true;
                }
                _this.aiScrollBottom();

                _this.chatSending = false;
              }
              // 如果需要每获取一段数据，就使用到一段数据，那就在这里使用，useData是你要使用这段数据来干嘛的函数
              list.forEach((item) => {
                if (
                  item.code == 500 ||
                  (item.last_error && item.last_error.code != 0)
                ) {
                  _this.$set(_this.chatList[_this.chatList.length - 1], "content", _this.chatList[_this.chatList.length - 1].content + "抱歉，未找到相关结果，建议调整输入内容");
                  _this.chatList[_this.chatList.length - 1].isFinish = true;
                  _this.aiScrollBottom();

                  _this.chatSending = false;
                } else if (item.content) {
                  if (item.type == "answer") {
                    _this.chatList[_this.chatList.length - 1].content +=
                      item.content;
                    _this.aiScrollBottom();
                  }
                }
              });

              // 把处理好后的数据合并到 buffer中
              buffer = buffer.concat(chunk);
              // 继续读取
              return read();
            });
          }
          // 开始读取
          return read();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    changeOptData(option) {
      let data = {};
      data["body"] = option;
      let sign = [];
      data.timestamp = parseInt(new Date().getTime() / 1000);
      data.app_id = config.app_id;
      let token = localStorage.getItem("token");
      data.authorization = token;
      let mdKey = "";
      Object.keys(data).forEach((key) => {
        sign.push(key);
      });
      sign.sort().forEach((item, index) => {
        mdKey += `${item}=${item == "body" ? JSON.stringify(data[item]) : data[item]
          }`;
      });
      data.sign = md5(`${mdKey}${config.app_secret}`);
      return data;
    },
    parseMultiJson(jsonStr) {
      const jsonArr = [];
      let startIndex = 0;
      let endIndex = 0;

      while (startIndex < jsonStr.length) {
        // 找到一个 JSON 对象的开始位置
        startIndex = jsonStr.indexOf("{", startIndex);
        if (startIndex === -1) {
          break;
        }

        // 找到一个 JSON 对象的结束位置
        let openBrackets = 1;
        endIndex = startIndex + 1;
        while (openBrackets > 0 && endIndex < jsonStr.length) {
          if (jsonStr[endIndex] === "{") {
            openBrackets++;
          } else if (jsonStr[endIndex] === "}") {
            openBrackets--;
          }
          endIndex++;
        }

        // 将该 JSON 对象解析为一个对象，并添加到数组中
        const json = jsonStr.substring(startIndex, endIndex);
        try {
          jsonArr.push(JSON.parse(json));
        } catch (e) {
          console.log("解析 JSON 对象失败", e);
        }

        // 更新下一个 JSON 对象的开始位置
        startIndex = endIndex;
      }

      return jsonArr;
    },
    aiScrollBottom() {
      this.$nextTick(() => {
        setTimeout(() => {
          let aiScrollContain =
            document.getElementsByClassName("aiScrollContain")[0];
          aiScrollContain.scrollTo({
            top: aiScrollContain.scrollHeight - aiScrollContain.clientHeight,
            left: 0,
            behavior: "smooth",
          });
        }, 500);
      });
    },
    suggestionEdit(index) {
      let content = this.editorMain.getContent();
      let reg = new RegExp(
        `<span class="wrongWord">${this.suggestionList[index].old}</span>`,
        "g"
      );
      content = content.replace(reg, this.suggestionList[index].new);
      this.editorMain.setContent(content);
      this.suggestionList.splice(index, 1);
    },
    suggestionEditAll() {
      let content = this.editorMain.getContent();
      this.suggestionList.forEach((item) => {
        let reg = new RegExp(`<span class="wrongWord">${item.old}</span>`, "g");
        content = content.replace(reg, item.new);
      });
      this.editorMain.setContent(content);
      this.suggestionList = [];
    },
    aiInsertContent(item) {
      if (item.titles) {
        if (this.chatTitleIndex == -1) {
          this.chatList.push({
            isUser: 1,
            content: "请选择标题",
          });

          this.aiScrollBottom();
        } else {
          this.title = item.titles[this.chatTitleIndex];

          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }
      } else if (item.question.indexOf("请根据内容进行摘要推荐") > -1) {
        this.abstractAi = item.content.replace(/\*\*摘要：\*\* /g, "");
        window.scrollTo({
          left: 0,
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      } else {
        var content = this.editorMain.getContent();
        this.lastSelection = this.editorMain.selection.getContent();
        if (this.lastSelection.length) {
          content = content.replace(this.lastSelection, item.content);
          this.editorMain.setContent(content);
        } else {
          this.editorMain.insertContent(item.content);
        }
      }
    },
    async aiCopy(index) {
      try {
        await navigator.clipboard.writeText(this.chatList[index].content);
        this.$message({
          message: "内容已复制到剪贴板",
          type: "success",
        });
      } catch (err) {
        this.$message.error("内容复制失败");
      }
    },
    aiReTry(item) {
      if (!item.binaryData) {
        this.aiCreateText(item.question);
      } else {
        this.getImageCaption(item.img, item.binaryData);
      }
    },
    aiTabShow(index) {
      this.aiIndex = index;
    },
    showSuggest() {
      if (
        this.editorMain
          .getContent()
          .indexOf(
            "https://obs.dingnews.net/image/20230321/f514bcbbc794acb60c862cb58d67c568.gif"
          ) >= 0
      ) {
        this.$message({
          message: "请等待图片加载完成后进行检测",
          type: "warning",
        });
        return;
      }
      if (this.aiIndex == 0 && this.getClearContent().length > 0) {
        this.getErrors();
      }
      this.aiIndex = 1;
    },
    reDoSuggestion() {
      if (
        this.editorMain
          .getContent()
          .indexOf(
            "https://obs.dingnews.net/image/20230321/f514bcbbc794acb60c862cb58d67c568.gif"
          ) >= 0
      ) {
        this.$message({
          message: "请等待图片加载完成后进行检测",
          type: "warning",
        });
      } else if (this.getClearContent().length > 0) {
        let content = this.editorMain.getContent();
        let reg = new RegExp('<span class="wrongWord">', "g");
        let reg1 = new RegExp("<</span>", "g");
        content = content.replace(reg, "").replace(reg1, "");
        this.editorMain.setContent(content);

        this.getErrors();
      }
    },
    getErrors() {
      if (this.aiSuggestionLoading) {
        return;
      }
      this.aiSuggestionLoading = true;
      this.suggestionList = [];
      let contentNow = this.getClearContent();
      let params = {
        content: contentNow,
      };
      if (this.$route.query.uid) {
        params.type = 2;
      }
      this.$axios
        .post(`${ROBOT_HOST}/api/ai/ecnet`, {
          ...params,
        })
        .then((res) => {
          this.aiSuggestionLoading = false;

          if (res.data.code == 0) {
            if (res.data.data) {
              for (let item in res.data.data) {
                if (item.replace(/[^\u4e00-\u9fa5]/g, "")) {
                  this.suggestionList.push({
                    old: item.replace(/[^\u4e00-\u9fa5]/g, ""),
                    new: res.data.data[item].replace(/[^\u4e00-\u9fa5]/g, ""),
                  });
                }
              }
              let content = this.editorMain.getContent();
              this.suggestionList.forEach((item) => {
                let reg = new RegExp(item.old, "g");
                content = content.replace(
                  reg,
                  `<span class="wrongWord">${item.old}</span>`
                );
              });
              this.editorMain.setContent(content);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    aiUploadImg() {
      this.isUploadAiText = false;
      this.isUploadAi = true;
      let upload = document.getElementById("uploadImg");
      upload.value = "";
      upload.click();
    },
    imgRadioCommand(e) {
      this.imgRadio.forEach((item, index) => {
        if (item.label == e) {
          this.imgRadioIndex = index;
        }
      });
    },
    imgStyleCommand(e) {
      this.imgStyle.forEach((item, index) => {
        if (item.text == e) {
          this.imgStyleIndex = index;
        }
      });
    },
    async aiImgSend() {
      if (this.imgCreating) {
        this.$message({
          message: "生成中，请稍后...",
          type: "warning",
        });
        return;
      }
      if (!this.chatImgInput) {
        this.imgChatList.push({
          isUser: 0,
          text: "请输入图片描述",
          img: "",
        });
        this.aiImgScrollBottom();
        return;
      }

      this.imgChatList.push({
        isUser: 1,
        text: `请为我${this.aiImgUpload ? "使用以上素材" : ""}生成图片：${this.chatImgInput
          }，使用${this.imgStyle[this.imgStyleIndex].text}风格`,
        img: this.aiImgUpload,
      });

      this.imgCreating = true;

      this.imgChatList.push({
        isUser: 0,
        text: "图片生成中...",
        img: "",
      });

      const imgDes = this.chatImgInput;
      const sendImg = this.aiImgUpload;
      this.chatImgInput = "";
      this.aiImgUpload = "";
      this.aiImgScrollBottom();

      if (this.aiImgUploadFile) {
        const baseImg = await this.imageToBase64(this.aiImgUploadFile);
        this.$axios
          .post(`${ROBOT_HOST}/api/ai/pictureToPicture`, {
            prompt:
              imgDes + `，使用${this.imgStyle[this.imgStyleIndex].text}风格`,
            binaryData: baseImg,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$set(this.imgChatList, this.imgChatList.length - 1, {
                isUser: 0,
                text: "",
                img: res.data.data,
                prompt:
                  imgDes +
                  `，使用${this.imgStyle[this.imgStyleIndex].text}风格`,
                binaryData: baseImg,
                sendImg: sendImg,
              });
              this.aiImgScrollBottom();

              this.aiImgUploadFile = "";
              this.aiImgUpload = "";
              this.imgCreating = false;
            } else {
              this.$set(this.imgChatList, this.imgChatList.length - 1, {
                isUser: 0,
                text: res.data.msg,
                img: "",
                prompt:
                  imgDes +
                  `，使用${this.imgStyle[this.imgStyleIndex].text}风格`,
                binaryData: baseImg,
                sendImg: sendImg,
              });
              this.aiImgScrollBottom();

              this.aiImgUploadFile = "";
              this.aiImgUpload = "";
              this.imgCreating = false;
            }
          });
      } else {
        const radioArray = this.imgRadio[this.imgRadioIndex].value.split("*");
        this.$axios
          .get(
            `${ROBOT_HOST}/api/ai/textToPicture?question=${imgDes}，使用${this.imgStyle[this.imgStyleIndex].text
            }风格&width=${radioArray[0]}&height=${radioArray[1]}`
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.$set(this.imgChatList, this.imgChatList.length - 1, {
                isUser: 0,
                text: "",
                img: res.data.data,
                question:
                  imgDes +
                  `，使用${this.imgStyle[this.imgStyleIndex].text}风格`,
                width: radioArray[0],
                height: radioArray[1],
              });
              this.aiImgScrollBottom();

              this.imgCreating = false;
            } else {
              this.$set(this.imgChatList, this.imgChatList.length - 1, {
                isUser: 0,
                text: res.data.msg,
                img: "",
                question:
                  imgDes +
                  `，使用${this.imgStyle[this.imgStyleIndex].text}风格`,
                width: radioArray[0],
                height: radioArray[1],
              });
              this.aiImgScrollBottom();

              this.imgCreating = false;
            }
          });
      }
    },
    async aiImgReTry(item) {
      if (this.imgCreating) {
        this.$message({
          message: "生成中，请稍后...",
          type: "warning",
        });
        return;
      }
      if (
        (item.binaryData && !item.prompt) ||
        (!item.binaryData && !item.question)
      ) {
        this.imgChatList.push({
          isUser: 0,
          text: "请输入图片描述",
          img: "",
        });
        this.aiImgScrollBottom();
        return;
      }

      if (item.binaryData) {
        this.imgChatList.push({
          isUser: 1,
          text: item.prompt
            ? `请为我使用以上素材生成图片：${item.prompt}`
            : "请为我生成图片",
          img: item.sendImg,
        });
      } else {
        this.imgChatList.push({
          isUser: 1,
          text: item.question
            ? `请为我生成图片：${item.question}`
            : "请为我生成图片",
          img: "",
        });
      }

      this.imgCreating = true;

      this.imgChatList.push({
        isUser: 0,
        text: "图片生成中...",
        img: "",
      });

      this.aiImgScrollBottom();

      if (item.binaryData) {
        this.$axios
          .post(`${ROBOT_HOST}/api/ai/pictureToPicture`, {
            prompt: item.prompt,
            binaryData: item.binaryData,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$set(this.imgChatList, this.imgChatList.length - 1, {
                isUser: 0,
                text: "",
                img: res.data.data,
                prompt: item.prompt,
                binaryData: item.binaryData,
              });
              this.aiImgScrollBottom();

              this.imgCreating = false;
            } else {
              this.$set(this.imgChatList, this.imgChatList.length - 1, {
                isUser: 0,
                text: res.data.msg,
                img: "",
                prompt: item.prompt,
                binaryData: item.binaryData,
              });
              this.aiImgScrollBottom();

              this.imgCreating = false;
            }
          });
      } else {
        this.$axios
          .get(
            `${ROBOT_HOST}/api/ai/textToPicture?question=${item.question}&width=${item.width}&height=${item.height}`
          )
          .then((res) => {
            if (res.data.code == 0) {
              this.$set(this.imgChatList, this.imgChatList.length - 1, {
                isUser: 0,
                text: "",
                img: res.data.data,
                question: item.question,
                width: item.width,
                height: item.height,
              });
              this.aiImgScrollBottom();

              this.imgCreating = false;
            } else {
              this.$set(this.imgChatList, this.imgChatList.length - 1, {
                isUser: 0,
                text: res.data.msg,
                img: "",
                question: item.question,
                width: item.width,
                height: item.height,
              });
              this.aiImgScrollBottom();

              this.imgCreating = false;
            }
          });
      }
    },
    aiImgInsertContent(item) {
      this.editorMain.insertContent(
        '<p><img src="' +
        item.img +
        '" width="100%" height="auto" data-mce-src="' +
        item.img +
        '" data-mce-selected="1"></p><p></p>'
      );
    },
    imageToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const dataURL = canvas.toDataURL();
            resolve(dataURL.replace("data:image/png;base64,", ""));
          };
          img.onerror = () => {
            reject(new Error("Failed to load image"));
          };
          img.src = event.target.result;
        };
        reader.onerror = (event) => {
          reject(new Error("Failed to read file"));
        };
        reader.readAsDataURL(file);
      });
    },
    aiImgScrollBottom() {
      this.$nextTick(() => {
        setTimeout(() => {
          let aiScrollContain =
            document.getElementsByClassName("aiScrollContain")[0];
          aiScrollContain.scrollTo({
            top: aiScrollContain.scrollHeight - aiScrollContain.clientHeight,
            left: 0,
            behavior: "smooth",
          });
        }, 500);
      });
    },
    insertTelFn() {
      if (/^1[3456789]\d{9}$/.test(this.insertTel)) {
        this.editorMain.insertContent(
          '<a href="tel:' + this.insertTel + '">' + this.insertTel + "</a>"
        );
        this.insertTelVisible = false;
      } else {
        this.$message({
          message: "请输入正确的手机号码",
          type: "warning",
        });
      }
    },
    insertLinkFn() {
      if (this.insertLinkUrl == "") {
        this.$message({
          message: "请输入链接地址",
          type: "warning",
        });
      } else if (
        this.editorMain.selection.getContent().indexOf("<img") < 0 &&
        this.insertLinkTitle == ""
      ) {
        this.$message({
          message: "请输入显示文字",
          type: "warning",
        });
      } else {
        if (this.editorMain.selection.getContent().indexOf("<img") > -1) {
          this.editorMain.selection.setContent(
            `<a href="${this.insertLinkUrl
            }">${this.editorMain.selection.getContent()}</a>`
          );
        } else {
          this.editorMain.insertContent(
            '<a href="' +
            this.insertLinkUrl +
            '">' +
            this.insertLinkTitle +
            "</a>"
          );
        }

        this.insertLinkVisible = false;
      }
    },
    async getImageCaption(url, binaryData) {
      if (this.chatSending) {
        this.$message({
          message: "助手正在回答中，请稍后...",
          type: "warning",
        });
        return;
      } else {
        this.chatSending = true;
      }

      this.chatList.push({
        isUser: 1,
        content: "请为以上图片生成配文",
        img: url,
      });
      this.chatList.push({
        isUser: 0,
        content: "生成中...",
      });
      this.aiScrollBottom();
      const baseImg = await this.imageToBase64(
        binaryData ? binaryData : this.aiImgTextFile
      );
      this.$axios
        .post(`${ROBOT_HOST}/api/ai/imageCaption`, {
          binaryData: baseImg,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$set(this.chatList, this.chatList.length - 1, {
              isUser: 0,
              content: res.data.data.join("<br>"),
              binaryData: binaryData ? binaryData : this.aiImgTextFile,
              isFinish: true,
              question: "",
              img: url,
            });
            this.aiScrollBottom();

            this.chatSending = false;
          } else {
            this.$message.error(res.data.msg);

            this.chatSending = false;
          }
        });
    },
    titleTooLong() {
      this.titleTooLongShow = true;

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    getLastDraft() {
      this.$axios
        .get(`${RESOURCE_HOST}/api/draft/search`, {
          type: 1,
          page: 1,
          size: 1,
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.returnData.length) {
              let ignoreDraft = JSON.parse(
                localStorage.getItem("ignoreDraft") || "[]"
              );

              if (!ignoreDraft.includes(res.data.data.returnData[0].nd_id)) {
                this.draftLatest = res.data.data.returnData[0];
              }
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    addIgnoreDraft() {
      let ignoreDraft = JSON.parse(localStorage.getItem("ignoreDraft") || "[]");

      if (!ignoreDraft.includes(this.draftLatest.nd_id)) {
        ignoreDraft.push(this.draftLatest.nd_id);
        localStorage.setItem("ignoreDraft", JSON.stringify(ignoreDraft));
      }

      this.draftLatest = {};
    },
    editDraft() {
      this.$router.push({
        path: "/scriptWrite",
        query: {
          draftId: this.draftLatest.nd_id,
        },
      });
    },
    toDraft() {
      let routeData = this.$router.resolve({
        path: "/draft",
        query: {},
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss">
.tabs>.select {
  width: 100px;
  height: 36px;
  border-radius: 6px;
  color: #333;
  font-weight: 600;
  background: white;
}

.tabs>.unselect {
  border-radius: 6px;
  /* background: #F6F7F9; */
  width: 100px;
  height: 36px;
  color: #666;
  font-weight: 500;
}

.elistItem {
  margin-top: 32px;
  background: white;
  padding-left: 15px;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: calc(100% - 10px);
  max-height: calc(100vh - 218px);
  overflow-y: auto;
  padding-bottom: 32px;

  /* border-radius: 6px; */
  .sourceItem {
    width: calc(50% - 4px);
    margin-bottom: 8px;
  }
}

.no_list {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 107px;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.tox-tinymce {
  border: 0px !important;
}

.tox-statusbar {
  border-top: 0px !important;
  display: none !important;
}

.left>>>li.el-menu-item.is-active {
  width: 100px !important;
}

.el-menu {
  border-right: 0px !important;
}

.imgRadioContain {
  display: flex;
  align-items: center;

  .aiRadioImg {
    width: 16px;
  }

  .aiRadioText {
    color: #333333;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
    margin-left: 8px;
  }
}

.imgStyleContain {
  display: flex;
  align-items: center;

  .aiStyleImg {
    width: 32px;
  }

  .aiStyleText {
    color: #333333;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
    margin-left: 8px;
  }
}
</style>

<style lang="scss" scoped>
@import "../../styles/base.scss";

.tox-dialog-wrap .progress-bar {
  position: absolute;
  background-color: #ffffffbf;
  width: 100%;
  height: 100%;
  z-index: 1;
}

/deep/.tox .tox-tbtn {
  margin: 2px 2px 3px 2px;
}

.memberContainer {
  min-width: 900px;
  background: #edf1f8;
  box-sizing: border-box;
  //height: 100vh;
  //overflow-y: scroll;

  .mainInnerContainer {
    width: 100%;
    background-color: #edf1f8;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    .editContain {
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      margin-top: 20px;
    }

    .box {
      width: 856px;
      background-color: white;
      padding: 28px 40px 0 40px;

      .draftContain {
        display: flex;
        align-items: center;
        width: 100%;
        height: 50px;
        border-radius: 8px;
        background: #f2f3f5;
        padding: 0 20px;
        margin-bottom: 32px;

        .draftLabel {
          color: #999999;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 400;
          line-height: 17px;
          padding-right: 12px;
          border-right: 1px solid #dfe3ea;
        }

        .draftTitle {
          flex: 1;
          padding: 0 12px;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 500;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .draftEdit {
          border-radius: 4px;
          border: 1px solid #e5e6eb;
          background: #fff;
          padding: 0 12px;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          line-height: 32px;
          cursor: pointer;
          margin-right: 16px;
        }

        .moreDraftContain {
          display: flex;
          align-items: center;
          cursor: pointer;

          .moreDraftContainTitle {
            color: #999999;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
          }

          .moreDraftContainIcon {
            height: 16px;
            margin-left: 2px;
          }
        }

        .closeDraft {
          height: 24px;
          margin-left: 42px;
          cursor: pointer;
        }
      }

      .script {
        min-height: 900px;

        .titleContain {
          border-bottom: 1px solid #e5e6eb;
          padding-bottom: 15px;
          position: relative;
          padding-right: 60px;
          margin-bottom: 15px;

          /deep/input::placeholder {
            color: #999999;
          }

          .titleLength {
            color: #999999;
            font-family: "PingFang SC";
            font-size: 15px;
            font-weight: 400;
            line-height: 25px;
            position: absolute;
            right: 0;
            top: 16px;
          }

          .toLong {
            color: #ea0e0e;
          }
        }

        .titleTooLongAlert {
          font-size: 14px;
          color: #ea0e0e;
          margin-top: 5px;
        }

        .title {
          height: 36px;
          width: 100%;
          font-size: 18px;
          text-align: left;
          margin-top: 10px;
          margin-bottom: 0;

          /deep/input {
            height: 36px;
            border: 0 !important;
            color: #333333;
            background: #fff !important;
            padding: 0;
          }

          /deep/input::placeholder {
            color: #999;
          }
        }
      }
    }

    .aiContain {
      width: 375px;
      height: calc(100vh - 170px);
      background: linear-gradient(180deg, #f3f4ff 0%, #f9fdff 100%);
      margin: 20px 0 0 20px;
      position: sticky;
      top: 92px;
      left: 50%;
      padding: 16px 24px 24px 24px;
      flex-shrink: 0;
      transition: height 0.4s;
      border-radius: 8px;
      z-index: 2;

      .aiNavContain {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 18px;

        .aiNavs {
          display: flex;
          align-items: center;
          color: #666666;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 400;
          line-height: 25px;

          .aiNav {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            margin-right: 10px;

            .aiNavLine {
              width: 20px;
              height: 2px;
              background: rgba(0, 0, 0, 0);
              margin-top: 4px;
            }
          }

          .aiActive {
            color: #333333;
            font-weight: bold;

            .aiNavLine {
              background: #ea0e0e;
            }
          }
        }

        .aiCloseIcon {
          height: 20px;
          cursor: pointer;
          margin-top: -4px;
        }
      }

      .aiContactContain {
        width: calc(100% + 10px);
        height: calc(100% - 50px);
        display: flex;
        flex-direction: column;

        .stableContain {
          width: 100%;
          padding: 4px 12px 16px 12px;
          background-color: #fff;
          border-radius: 8px;
          margin-bottom: 16px;
          position: sticky;
          top: 0;
          left: 0;
          z-index: 1;

          .stableText {
            color: #666666;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-top: 12px;
          }

          .aiFunContain {
            display: flex;
            flex-wrap: wrap;
            margin-top: 12px;

            .aiFunItem {
              padding: 0 12px;
              background: linear-gradient(91deg, #ffe6e0 0%, #d6e1fd 100%);
              color: #333333;
              font-family: "PingFang SC";
              font-size: 12px;
              font-weight: 400;
              line-height: 28px;
              border-radius: 4px;
              margin: 0 8px 8px 0;
              cursor: pointer;
            }
          }
        }

        .chatContain {
          .chatList {
            padding: 0 0 24px 32px;
            position: relative;

            .chatHead {
              height: 22px;
              position: absolute;
              left: 0;
              top: 0;
              border-radius: 50%;
            }

            .chatName {
              color: #999999;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 22px;
            }

            .chatImg {
              width: 187px;
              margin-top: 8px;
            }

            .chatContent {
              width: fit-content;
              padding: 16px 12px;
              background-color: #fff;
              border-radius: 8px;
              color: #333333;
              text-align: justify;
              font-family: "PingFang SC";
              font-size: 16px;
              font-weight: 400;
              line-height: 26px;
              margin-top: 8px;
            }

            .chatTitle {
              .chatTitleText {
                padding: 16px 12px;
                background-color: #fff;
                border-radius: 8px;
                margin-top: 8px;
                cursor: pointer;
                color: #333333;
                font-family: "PingFang SC";
                font-size: 16px;
                font-weight: 400;
                line-height: 25px;
                border: 1px solid #fff;
              }

              .chatTitleActive {
                border: 1px solid #ea0e0e;
              }
            }

            .aiAlert {
              color: #999999;
              font-family: "PingFang SC";
              font-size: 12px;
              font-weight: 400;
              line-height: 17px;
              margin-top: 8px;
            }

            .btnContain {
              display: flex;
              margin-top: 16px;
              color: #333333;
              font-family: "PingFang SC";
              font-size: 12px;
              font-weight: 400;
              line-height: 28px;

              .addToContent {
                background: linear-gradient(91deg, #ffe6e0 0%, #d6e1fd 100%);
                border-radius: 4px;
                padding: 0 12px;
                cursor: pointer;
                margin-right: 8px;
              }

              .copyBtn {
                border: 1px solid #cccccc;
                border-radius: 4px;
                padding: 0 12px;
                cursor: pointer;
                margin-right: 8px;
              }

              .reTryBtn {
                border: 1px solid #cccccc;
                border-radius: 4px;
                padding: 0 12px;
                cursor: pointer;
              }
            }
          }
        }

        .aiScrollContain {
          flex: 1;
          overflow-y: auto;
          position: relative;
          border-radius: 8px;
          overscroll-behavior: contain;
          padding-right: 10px;

          &::-webkit-scrollbar {
            width: 6px !important;
          }

          &::-webkit-scrollbar-track-piece {
            background: linear-gradient(180deg, #f3f4ff 0%, #f9fdff 100%);
          }
        }

        .chatInputContain {
          width: calc(100% - 10px);
          border-radius: 22px;
          background: #fff;
          box-shadow: 0 4px 8px 0 #cccccc40;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-right: 6px;
          margin-top: 16px;

          .chatInput {
            color: #333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            flex: 1;
            padding: 0 12px;
          }

          .aiSendIcon {
            height: 32px;
            cursor: pointer;
          }
        }

        .chatAiInputContain {
          display: block;
          padding: 12px 6px 8px 12px;
          height: fit-content;

          .aiImgUploadedContain {
            width: 48px;
            height: 48px;
            margin-bottom: 16px;
            position: relative;

            .aiImgUploaded {
              width: 100%;
              height: 100%;
              border-radius: 4px;
            }

            .aiImgDeleteClose {
              height: 16px;
              position: absolute;
              right: 0;
              top: 0;
              cursor: pointer;
            }
          }

          .chatInput {
            width: 100%;
            margin-bottom: 28px;
            padding: 0;
            height: 20px;
          }

          .imgInfoContain {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .btnContain {
              display: flex;

              .uploadAiImg {
                display: flex;
                align-items: center;
                border: 1px solid #cccccc;
                border-radius: 4px;
                margin-right: 8px;
                cursor: pointer;
                padding: 5px 8px;

                .aiUploadIcon {
                  height: 16px;
                  margin-right: 2px;
                }

                .aiUploadText {
                  min-width: 24px;
                  color: #333333;
                  font-family: "PingFang SC";
                  font-size: 12px;
                  font-weight: 400;
                }
              }
            }
          }
        }
      }

      .aiSuggestionContain {
        height: calc(100% - 50px);
        overflow-y: scroll;

        .checkContain {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .suggestionText {
            color: #666666;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;

            .suggestionNum {
              color: #ea0e0e;
            }
          }
        }

        .reCheckContain {
          display: flex;
          align-items: center;
          cursor: pointer;

          .refreshIcon {
            height: 16px;
            margin-right: 4px;
          }

          .reCheckText {
            color: #333333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 500;
          }
        }

        .noWrongWord {
          line-height: 44px;
          background-color: #fff;
          border-radius: 8px;
          color: #333333;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          margin-top: 24px;
        }

        .wrongCountContain {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .correctWordContain {
            display: flex;
            align-items: center;
            cursor: pointer;

            .correctWordIcon {
              height: 16px;
            }

            .correctWordText {
              color: #333333;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              line-height: 20px;
              margin-left: 4px;
            }
          }
        }

        .suggestionLength {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
          margin-top: 24px;
          padding-bottom: 8px;
        }

        .suggestionListContain {
          width: 100%;

          .suggestionItem {
            width: 100%;
            display: flex;
            align-items: center;
            color: #333333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            justify-content: space-between;
            margin-top: 16px;

            .suggestionInner {
              display: flex;
              align-items: center;

              .dot {
                width: 4px;
                height: 4px;
                border-radius: 2px;
                background: #333;
                margin-right: 6px;
              }

              .suggestionIcon {
                height: 8px;
                margin: 0 4px;
              }
            }

            .editBtn {
              color: #165dff;
              cursor: pointer;
              flex-shrink: 0;
              margin-left: 10px;
            }
          }
        }

        /deep/.el-loading-mask {
          background: linear-gradient(180deg,
              #f3f4ff 0%,
              #f9fdff 100%) !important;
        }
      }
    }

    .deepseekContain {
      width: calc(100% + 10px);
      height: calc(100% - 50px);

      iframe {
        width: 100%;
        height: 100%;
      }
    }

    .scrollHeigth {
      height: calc(100vh - 112px);
    }
  }

  /deep/.previewContainer {
    .el-dialog {
      background: url(../../assets/script/preview.png) no-repeat;
      background-size: 100% 100%;
      height: 670px;
      border-radius: 40px;
      padding-top: 70px;
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      height: 519px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      padding-left: 22px;
      padding-right: 22px;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #ccc;
      }

      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
      }

      .closeBtn {
        position: absolute;
        top: 0;
        left: 332px;
        height: 32px;
        cursor: pointer;
      }

      .title {
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 31px;
        margin-bottom: 10px;
      }

      .info {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        img {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          margin-right: 20px;
        }

        .userName {
          font-size: 14px;
          line-height: 20px;
        }

        .time {
          line-height: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }

      .content {
        font-size: 18px !important;
        color: #333;
        line-height: 1.71 !important;

        img,
        video {
          height: auto;
          max-width: 100% !important;
          margin: 0 auto !important;
          display: block;
        }

        video {
          width: 100%;
        }

        p {
          font-size: 18px !important;
          color: #333;
          line-height: 1.71 !important;
          word-break: break-all;
          margin-top: 15px;
          max-width: 100% !important;
          overflow-x: hidden;
        }

        span {
          font-size: 18px !important;
          color: #333;
          line-height: 1.71 !important;
        }

        div {
          font-size: 18px !important;
          color: #333;
          line-height: 1.71 !important;
          word-break: break-all;
        }

        figure.image {
          margin: 15px 0 0 0;
        }

        figure.image figcaption {
          color: #999;
          display: block;
          margin-top: 0.25rem;
          text-align: center;
          font-size: 16px;
        }

        section {
          font-size: 18px !important;
          color: #333;
          line-height: 1.7 !important;
          letter-spacing: 0.8px !important;
          max-width: 100% !important;
          overflow-x: hidden;
          //text-indent: 0 !important;
          margin-top: 15px;
        }
      }
    }
  }

  /deep/.insertTopicContainer {
    .el-dialog__body {
      padding-bottom: 10px;
    }

    .el-select {
      width: 100%;
    }

    .el-input {
      width: 100%;
      margin-bottom: 0;
    }

    .el-input__inner {
      width: 100%;
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }

  .uploadVideoBg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(255, 255, 255, 0.75);
    z-index: 1;
  }

  /deep/.insertImgContainer {
    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }

    .el-dialog__body {
      padding-top: 0;
      padding-left: 32px;
      padding-right: 32px;

      .el-tabs__nav-wrap::after {
        height: 0;
      }

      .el-tabs__item {
        font-size: 16px;
        height: 40px;
      }

      .uploadImgContain {
        height: 400px;

        .myMatriList {
          display: flex;
          flex-wrap: wrap;
          padding-top: 17px;

          .matriListContain {
            width: 93px;
            height: 93px;
            border-radius: 4px;
            margin: 0 12px 12px 0;
            border: 1px solid #fff;
            cursor: pointer;

            .matriImg {
              width: 100%;
              height: 100%;
              border-radius: 4px;
            }

            &:nth-child(6n) {
              margin-right: 0;
            }
          }

          .matriActive {
            border: 1px solid #ea0e0e;
          }
        }

        .noMatri {
          color: #999999;
          font-family: "PingFang SC";
          font-size: 12px;
          font-weight: 400;
          text-align: center;
          padding: 20px 0;
        }
      }

      .shaortUpload {
        height: 120px;

        .uploadBtn {
          margin-top: -10px;
        }
      }

      .el-tab-pane {

        &:nth-child(2),
        &:nth-child(3) {
          .uploadImgContain {
            overflow-y: scroll;
          }
        }
      }

      .localImg {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .uploadBtn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 122px;
          height: 36px;
          border-radius: 4px;
          background: #ea0e0e;
          color: #ffffff;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;

          .uploadIcon {
            height: 16px;
            margin-right: 4px;
          }
        }

        .uploadInfo {
          color: #999999;
          text-align: center;
          font-family: "PingFang SC";
          font-size: 12px;
          font-weight: 400;
          line-height: 17px;
          margin-top: 12px;
        }
      }

      .uploadImgUrlsContain {
        display: flex;
        flex-wrap: wrap;
        min-height: 280px;

        .uploadImgUrlInner {
          width: 96px;
          height: 96px;
          margin: 0 12px 12px 0;
          position: relative;

          .uploadedImg {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }

          .deleteImg {
            width: 22px;
            position: absolute;
            right: 0;
            top: 0px;
            cursor: pointer;
          }

          &:nth-child(6n) {
            margin-right: 0;
          }
        }
      }
    }

    .el-dialog__footer {
      padding-top: 0;
    }
  }

  /deep/.insertLinkContainer {
    .el-dialog__body {
      padding-bottom: 10px;

      .insertLinkContain {
        display: flex;
        align-items: center;
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }

        .insertLinkLabel {
          width: 88px;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 500;
        }

        .insertLink {
          margin-bottom: 0;

          input {
            width: 100%;
            border-radius: 2px;
            background: #f6f7f9;
            border: 0;
            height: 40px;
          }
        }
      }
    }

    .el-dialog__footer {
      padding-top: 10px;
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }

  /deep/.insertTelContainer {
    .insertTel {
      width: 100%;
      margin-bottom: 0;

      input {
        width: 100%;
        border-radius: 2px;
        background: #f6f7f9;
        border: 0;
        height: 40px;
      }
    }

    .el-dialog__body {
      padding-bottom: 10px;
    }

    .el-dialog__footer {
      padding-top: 10px;
    }

    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }
}

/deep/.submitBtnContainer {
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0) !important;
  box-shadow: 0 0 0 rgba(0, 21, 41, 0.08) !important;

  .innerContainer {
    padding: 0 40px;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    margin-left: -395px;
  }
}

/deep/.navbar {
  box-shadow: none;
}

/deep/.tox-tinymce-inline {
  display: block !important;
}

/deep/.mce-edit-focus {
  outline: 0 !important;
}

#external-toolbar {
  position: sticky;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 10;

  /deep/.tox-editor-header {
    border: 0;
    background: #f9fbff;

    .tox-toolbar__primary {
      background: #f9fbff !important;
      align-items: center;
      margin-left: -261px;

      .tox-toolbar__group {
        &:nth-child(3) {
          border-right: 0;
        }

        &:last-child {
          margin-left: 218px;

          .tox-tbtn {
            width: 112px;
            cursor: pointer;
          }

          .tox-tbtn:hover,
          .tox-tbtn:focus {
            background: #f9fbff00 !important;
          }

          .tox-icon {
            width: 112px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 14px;
            border: 1px solid #e5e6eb;

            svg {
              display: inline-block;
            }

            span {
              color: #000000;
              font-family: "PingFang SC";
              font-size: 14px;
              font-weight: 400;
              margin-left: 6px;
              line-height: 24px;
            }
          }
        }
      }
    }

    .tox-toolbar-overlord {
      background: #f9fbff !important;
      display: flex;
      justify-content: center;
      height: 72px;

      .tox-toolbar__group {
        height: 34px;
      }
    }
  }

  /deep/.tox-toolbar {
    .tox-tbtn[title="扩写"],
    .tox-tbtn[title="润色"] {
      width: 70px;
    }

    .tox-tbtn[title="修改语气"] {
      width: 100px;
    }

    .tox-icon {
      display: flex;
      align-items: center;

      svg {
        margin-right: 4px;
      }
    }
  }

  /deep/.tox-dialog__footer {
    border-top: 0;
  }

  /deep/.tox {
    .tox-button {
      width: 80px;
      line-height: 26px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      font-size: 14px;
      font-family: PingFangSC-Medium PingFang SC sans-serif;
      font-weight: 500;
    }

    .tox-button--secondary {
      width: 80px;
      line-height: 26px;
      background-color: #fff;
      border-color: #dcdfe6;
      color: #333;
      font-size: 14px;
      font-family: PingFangSC-Medium PingFang SC sans-serif;
      font-weight: 500;
    }

    .tox-button--naked {
      width: 22px;
      background-color: #fff;
      border-color: #fff;
    }
  }

  /deep/.tox-dialog {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    border-radius: 2px;
    border: 0 !important;
    padding-bottom: 15px;
    margin-top: -160px;

    .tox-dialog__header {
      padding: 15px 20px 10px 20px;

      .tox-dialog__title {
        line-height: 24px;
        font-size: 18px;
        color: #303133;
      }
    }

    .tox-textfield {
      border-radius: 2px;
      background: #f6f7f9;
      border: 0;
      height: 40px;
      padding: 0 15px;
      font-size: 14px;
    }

    .tox-dialog__footer {
      padding-top: 16px;

      .tox-button {
        width: fit-content;
        min-width: 80px;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}

/deep/.mce-content-body {
  min-height: 790px;
  padding-bottom: 65px;
  position: relative;

  figure figcaption {
    color: #999;
    display: block;
    margin-top: 0.25rem;
    text-align: center;
  }

  p {
    font-size: 18px !important;
    color: #333;
    line-height: 1.71 !important;
    margin-top: 15px;
    max-width: 100% !important;
    overflow-x: hidden;
  }

  section {
    font-size: 18px !important;
    color: #333;
    line-height: 1.71 !important;
    max-width: 100% !important;
    overflow-x: hidden;
    margin-top: 15px;
  }

  div {
    font-size: 18px !important;
    color: #333;
    line-height: 1.71 !important;
  }

  figure {
    max-width: 60%;
    margin: 15px auto 0 auto;

    img {
      max-width: 100% !important;
    }
  }

  img {
    height: auto;
    display: block;
    max-width: 60% !important;
    margin: 0 auto !important;
    min-height: 10px;
  }

  span {
    font-size: 18px !important;
    color: #333;
    line-height: 1.71 !important;
  }

  .get-cover p {
    width: 100%;
    height: 24px;
    text-align: center;
    color: #bbb;
    margin-top: 0 !important;
  }

  .get-cover {
    width: 60%;
    min-height: 264px;
    border: 1px solid #e8e8e8;
    background-color: #00000040;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px auto 0 auto;
    position: relative;
  }

  .get-cover .videoCover {
    max-width: 100% !important;
    width: 100%;
  }

  .get-cover .tip {
    position: absolute;
    left: 0;
    bottom: -1px;
    font-size: 12px !important;
    color: #fff;
    width: 100%;
    line-height: 32px !important;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.32);
    border-radius: 4px;
  }

  .get-cover .videoIcon {
    width: 40px;
    height: 40px;
    min-height: 40px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -20px 0 0 -20px !important;
  }

  .get-cover .videoProcessContain {
    width: 364px;
    background-color: #ffffff40;
    height: 6px;
    border-radius: 8px;
  }

  .get-cover .videoProcess {
    background-color: #ffffff;
    height: 6px;
    border-radius: 8px;
  }

  section {
    font-size: 18px !important;
    color: #333;
    line-height: 1.7 !important;
    letter-spacing: 0.8px !important;
    max-width: 100% !important;
    margin-top: 15px;
  }

  .wrongWord {
    text-decoration-line: underline;
    text-decoration-style: wavy;
    text-decoration-color: #ea0e0e;
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;
  }

  dd-audio {
    width: 60% !important;
    margin: 20px auto 0 auto !important;
  }

  .mce-object-video {
    height: auto;
    display: block;
    max-width: 60% !important;
    margin: 0 auto !important;
  }

  .mce-resizehandle {
    z-index: 0 !important;
  }
}

.mce-content-body::before {
  color: #999 !important;
  /* 占位符颜色 */
  font-size: 18px;
  line-height: 1.71;
}
</style>
